// extracted by extract-css-chunks-webpack-plugin
module.exports = {"assessedActivities":"assessors-table-row__assessedActivities--1bEml"};